var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReservationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "6.33 8.42 87.33 85.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.3333 91.6667H41.6667C25.9532 91.6667 18.0965 91.6667 13.2149 86.785C8.33334 81.9038 8.33334 74.0467 8.33334 58.3334V50C8.33334 34.2865 8.33334 26.4298 13.2149 21.5482C18.0965 16.6667 25.9532 16.6667 41.6667 16.6667H58.3333C74.0467 16.6667 81.9038 16.6667 86.785 21.5482C91.6667 26.4298 91.6667 34.2865 91.6667 50V58.3334C91.6667 74.0467 91.6667 81.9038 86.785 86.785C84.0633 89.5067 80.4171 90.7109 75 91.2438",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1667 16.6667V10.4167",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8333 16.6667V10.4167",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5833 37.5H69.2708H44.7917M8.33334 37.5H24.4792",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70.8334C75 73.1346 73.1346 75 70.8333 75C68.5321 75 66.6667 73.1346 66.6667 70.8334C66.6667 68.5321 68.5321 66.6667 70.8333 66.6667C73.1346 66.6667 75 68.5321 75 70.8334Z",
    fill: "#f08417"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54.1667C75 56.4679 73.1346 58.3333 70.8333 58.3333C68.5321 58.3333 66.6667 56.4679 66.6667 54.1667C66.6667 51.8654 68.5321 50 70.8333 50C73.1346 50 75 51.8654 75 54.1667Z",
    fill: "#f08417"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1667 70.8334C54.1667 73.1346 52.3013 75 50 75C47.6988 75 45.8333 73.1346 45.8333 70.8334C45.8333 68.5321 47.6988 66.6667 50 66.6667C52.3013 66.6667 54.1667 68.5321 54.1667 70.8334Z",
    fill: "#f08417"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1667 54.1667C54.1667 56.4679 52.3013 58.3333 50 58.3333C47.6988 58.3333 45.8333 56.4679 45.8333 54.1667C45.8333 51.8654 47.6988 50 50 50C52.3013 50 54.1667 51.8654 54.1667 54.1667Z",
    fill: "#f08417"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 70.8334C33.3333 73.1346 31.4678 75 29.1667 75C26.8655 75 25 73.1346 25 70.8334C25 68.5321 26.8655 66.6667 29.1667 66.6667C31.4678 66.6667 33.3333 68.5321 33.3333 70.8334Z",
    fill: "#f08417"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 54.1667C33.3333 56.4679 31.4678 58.3333 29.1667 58.3333C26.8655 58.3333 25 56.4679 25 54.1667C25 51.8654 26.8655 50 29.1667 50C31.4678 50 33.3333 51.8654 33.3333 54.1667Z",
    fill: "#f08417"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationIcon);
export default __webpack_public_path__ + "static/media/reservation-icon.f2b6f24d927c4bd686b0deb2cede4a45.svg";
export { ForwardRef as ReactComponent };